module.exports = __webpack_public_path__ + "files/So-you-think-you-have-a-strategy PRE READING.6b2bdc13.pdf";